import { createAtomObserver } from '@exodus/atoms';
const createAssetSourcesLifecyclePlugin = ({ port, availableAssetNamesByWalletAccountAtom, }) => {
    const observer = createAtomObserver({
        port,
        atom: availableAssetNamesByWalletAccountAtom,
        event: 'availableAssetNamesByWalletAccount',
    });
    const onLoad = () => {
        observer.start();
    };
    const onStop = () => {
        observer.unregister();
    };
    return { onLoad, onStop };
};
const AssetSourcesLifecyclePluginDefinition = {
    id: 'assetSourcesLifecyclePlugin',
    type: 'plugin',
    factory: createAssetSourcesLifecyclePlugin,
    dependencies: ['port', 'availableAssetNamesByWalletAccountAtom'],
    public: true,
};
export default AssetSourcesLifecyclePluginDefinition;
